import type { RegionStats } from '../core/types';

/**
 * Framed-region dimensions, overlaid in the top-left of the 3D view: physical size
 * in metres (mm precision) over the capture resolution in pixels. The trailing
 * units (m / px) carry the meaning, so no labels. Hidden until a surface is picked.
 */
export function DimsOverlay({ region }: { region: RegionStats | null }) {
  if (!region) return null;
  return (
    <div className="pf-dims-overlay">
      <span className="pf-dims-phys">
        {region.worldWidth.toFixed(3)} × {region.worldHeight.toFixed(3)} m
      </span>
      <span className="pf-dims-px">
        {region.idealWidth} × {region.idealHeight} px{region.fallback ? ' · estimated' : ''}
      </span>
    </div>
  );
}
